import style from './block.module.scss';
import { BlockWrapper, ChildrenBlock, defineBlock, useChildrenBlocks, useEditor } from '@smartfire/js-block-engine';
import { ReactComponent as LogoBG } from './logoBG.svg';

function PageHeader({ content }) {
    const { isEditing } = useEditor();
    const { children } = useChildrenBlocks();

    return (
        <BlockWrapper.Div className={style.block}>
            <div className={style.content}>
                <LogoBG className={style.logo} />
                {content && (
                    <div className={style.textContent}>
                        <h4>Nos marchés</h4>
                        <h1>{content.title}</h1>
                        <p className={style.excerpt}>{content.excerpt}</p>
                    </div>
                )}
                {isEditing ? (
                    <ChildrenBlock
                        gutenbergEditorConfig={{
                            template: [
                                ['core/heading', { level: 4, placeholder: 'Sous-titre' }],
                                ['core/heading', { level: 1 }],
                                ['core/paragraph', { placeholder: 'Description' }],
                            ],
                            templateLock: 'all',
                        }}
                        className={style.textContent}
                    />
                ) : (
                    <div className={style.textContent}>
                        {Object.values(children).map((child, id) => {
                            return <>{child?.props?.children?.length > 0 && child}</>;
                        })}
                    </div>
                )}
            </div>
        </BlockWrapper.Div>
    );
}

export default defineBlock({
    Block: PageHeader,
    smartProps: {},
    setup: {
        title: 'Page Header',
    },
});
